<div class="container">
  <button
    data-cy="project_name"
    class="section-button"
    (click)="openProjectNotes()"
    i18n-matTooltip
    matTooltip="Projektinformationen"
    [matTooltipShowDelay]="1000"
    mat-button
  >
    <mat-icon>info</mat-icon>
    <div class="project-label-and-statement">
      <div class="label">{{ projectService.getProjectName() }}</div>
      <div class="decision-statement">{{ decisionData.decisionStatement.statement }}</div>
    </div>
  </button>

  @if (projectService.getProjectType() !== 'embedded') {
    <mat-divider vertical></mat-divider>
    @if (projectService.getProjectType() === 'local') {
      <button
        (click)="saveNonOnlineProject()"
        matTooltip="Projekt speichern"
        i18n-matTooltip
        [matTooltipShowDelay]="1000"
        mat-icon-button
        data-cy="save-non-online-project-button"
      >
        <mat-icon>save</mat-icon>
      </button>
    }
    @if (projectService.getProjectType() === 'online') {
      <button
        (click)="sideBySideService.openHistory()"
        matTooltip="Versionsverlauf"
        [matTooltipShowDelay]="1000"
        i18n-matTooltip
        mat-icon-button
        data-cy="project-history-button"
      >
        <mat-icon>history</mat-icon>
      </button>
    }
    @switch (autoSaveService.saveState$ | async) {
      @default {
        @switch (saveState$ | async) {
          @case ('off') {
            @if (onlineProject) {
              <mat-icon matTooltip="Du hast eine Sicherung geladen. Um sie wiederherzustellen, öffne den Versionsverlauf." i18n-matTooltip
                >cloud_off</mat-icon
              >
            }
            @if (teamProject) {
              <mat-icon matTooltip="Du besitzt aktuell nicht das Bearbeitungsrecht für dieses Teamprojekt." i18n-matTooltip
                >cloud_off</mat-icon
              >
            }
          }
          @case ('saving') {
            <mat-icon matTooltip="Projekt wird gespeichert…" i18n-matTooltip>cloud_upload</mat-icon>
          }
          @case ('idle') {
            <mat-icon
              [matTooltipDisabled]="!onlineProject"
              matTooltip="Zuletzt gespeichert {{ onlineProject?.info.updatedAt | timeAgo }}"
              i18n-matTooltip
              >cloud_done</mat-icon
            >
          }
          @case ('error') {
            <mat-icon class="error-icon" [matTooltip]="saveErrorMessage" data-cy="autosave-error-icon">cloud_off</mat-icon>
          }
        }
      }
    }
    @if (decisionData.projectMode !== 'starter') {
      <button (click)="openIssueRaising()" matTooltip="Ideen-Pool" i18n-matTooltip [matTooltipShowDelay]="1000" mat-icon-button>
        <mat-icon>category</mat-icon>
      </button>
    }
  }
</div>

@if (isTeamProject) {
  <div class="container">
    <button
      data-cy="team-dashboard-button"
      class="section-button"
      (click)="openTeamDashboard()"
      i18n-matTooltip
      matTooltip="Team-Dashboard"
      [matTooltipShowDelay]="1000"
      mat-button
    >
      <mat-icon>groups</mat-icon>
      <div class="label" i18n>Team-Dashboard</div>
      <mat-icon class="team-edit-icon" [class.can-edit]="teamProject.canSave" iconPositionEnd>{{
        teamProject.canSave ? 'edit' : 'edit_off'
      }}</mat-icon>
    </button>
  </div>
}
